import { Component } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { MxAppColorSchemeService, MxIdentityService } from '../../services';
import { MainComponent } from './main.component';

@Component({ standalone: false,
  selector: 'mx-topbar',
  template: `
    <div class="layout-topbar">
      <div class="layout-topbar-left">
        <a
          href="#"
          class="topbar-menu-button"
          (click)="main.onMenuButtonClick($event)"
          *ngIf="main.isOverlay() || main.isMobile()"
        >
          <i class="fa fa-bars fa-fw"></i>
        </a>

        <a href="#" class="logo">
          <img
            [src]="
              'assets/images/logo-' +
              (appColorSchemeService.colorScheme === 'light'
                ? 'dark'
                : 'light') +
              '.png'
            "
          />
        </a>
      </div>

      <mx-menu></mx-menu>

      <div class="layout-topbar-right">
        <ul class="layout-topbar-right-items">
          <li
            #profile
            class="profile-item"
            [ngClass]="{
              'active-topmenuitem': main.activeTopbarItem === profile
            }"
          >
            <a href="#" (click)="main.onTopbarItemClick($event, profile)">
              <img src="assets/images/profile-image.png" />
            </a>

            <ul class="fadeInDown">
              <!-- <li role="menuitem">
                                <a href="#" (click)="main.onTopbarSubItemClick($event)">
                                    <i class="fa fa-user fa-fw"></i>
                                    <span>{{'page:Profile' | i18next}}</span>
                                </a>
                            </li> -->
              <!-- <li role="menuitem" style="cursor:pointer;">
                <a [routerLink]="['settings']">
                  <i class="fa fa-cog fa-fw"></i>
                  <span>{{ 'page:Settings' | i18next }}</span>
                </a>
              </li> -->
              <li role="menuitem" style="cursor:pointer;">
                <a [routerLink]="" (click)="this.identityService.logout()">
                  <i class="fa fa-power-off fa-fw"></i>
                  <span>{{ 'Logout' | i18next }}</span>
                </a>
              </li>
            </ul>
          </li>
          <!-- <li>
                        <a href="#">
                            <i class="topbar-icon fa fa-bell fa-fw"></i>
                            <span class="topbar-badge">2</span>
                            <span class="topbar-item-name">Notifications</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i class="topbar-icon fa fa-comment-alt fa-fw"></i>
                            <span class="topbar-badge">5</span>
                            <span class="topbar-item-name">Messages</span>
                        </a>
                    </li> -->
        </ul>
      </div>
    </div>
  `,
})
export class TopbarComponent {
  constructor(
    public main: MainComponent,
    public appColorSchemeService: MxAppColorSchemeService,
    public identityService: MxIdentityService
  ) {}
}
